import { useState } from 'react';
import axios from "../../api/newAxios";
import Cookies from "universal-cookie";
import { TOKEN } from "../../config";
import { useQueryClient } from '@tanstack/react-query';

const useLeaveEncashment = () => {
    const cookies = new Cookies();
    const queryClient = useQueryClient();
    const [isLoading, setIsLoading] = useState(false);
    const [isEditLoading, setIsEditLoading] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);

    // Invalidate queries to refresh data
    const invalidateLeaveEncashmentQueries = () => {
        queryClient.invalidateQueries(['leave_encashment_listing']);
        queryClient.invalidateQueries(['getUserLeaveCount']);
    };

    // Fetch encashment details for editing
    const fetchEncashmentDetails = async (id) => {
        setIsEditLoading(true);
        try {
            const token = cookies.get(TOKEN);
            let fd = new FormData();
            fd.append('employee_leave_encashment_id', id);
            
            const response = await axios({
                method: "POST",
                data: fd,
                url: '/leave_encashment_edit',
                headers: { Authorization: token ? `Bearer ${token}` : '' }
            });
            
            setIsEditLoading(false);
            if (response.data && response.data.data) {
                return response.data.data;
            }
            return null;
        } catch (error) {
            setIsEditLoading(false);
            console.error("Error fetching encashment details:", error);
            throw error;
        }
    };

    // Create or update encashment
    const createOrUpdateEncashment = async (formData, userId, monthYear, isEditing) => {
        setIsLoading(true);
        try {
            const token = cookies.get(TOKEN);
            let fd = new FormData();
            
            if (isEditing) {
                fd.append('employee_leave_encashment_id', formData.employee_leave_encashment_id);
            }
            
            fd.append('user_id', userId);
            fd.append('month_year', monthYear);
            fd.append('encashment_type', formData.encashment_type);
            fd.append('encashment_action', formData.encashment_action);
            fd.append('encashment_count', formData.encashment_count);
            fd.append('remarks', formData.remarks || '');
            
            const response = await axios({
                method: "POST",
                data: fd,
                url: '/leave_encashment_create_and_update',
                headers: { Authorization: token ? `Bearer ${token}` : '' }
            });
            
            // Invalidate queries to refresh data
            invalidateLeaveEncashmentQueries();
            
            setIsLoading(false);
            return response.data;
        } catch (error) {
            setIsLoading(false);
            console.error("Error saving encashment:", error);
            if (error.response && error.response.data && error.response.data.message) {
                throw new Error(error.response.data.message);
            }
            throw error;
        }
    };

    // Delete encashment
    const deleteEncashment = async (id) => {
        setIsDeleteLoading(true);
        try {
            const token = cookies.get(TOKEN);
            let fd = new FormData();
            fd.append('employee_leave_encashment_id', id);
            
            const response = await axios({
                method: "POST",
                data: fd,
                url: '/leave_encashment_delete',
                headers: { Authorization: token ? `Bearer ${token}` : '' }
            });
            
            // Invalidate queries to refresh data
            invalidateLeaveEncashmentQueries();
            
            setIsDeleteLoading(false);
            return response.data;
        } catch (error) {
            setIsDeleteLoading(false);
            console.error("Error deleting encashment:", error);
            if (error.response && error.response.data && error.response.data.message) {
                throw new Error(error.response.data.message);
            }
            throw error;
        }
    };

    return {
        fetchEncashmentDetails,
        createOrUpdateEncashment,
        deleteEncashment,
        isLoading,
        isEditLoading,
        isDeleteLoading
    };
};

export default useLeaveEncashment;
